import { useCompositionStore } from "../../stores/compositionStore.js";
import { Button } from "../../ui/Button.js";

export function UndoButton(): JSX.Element {
  const status = useCompositionStore((s) => s.undoUi.status);
  const error = useCompositionStore((s) => s.undoUi.error);
  const onClick = (): void => {
    void useCompositionStore
      .getState()
      .undo()
      .catch(() => {
        /* recorded in undoUi */
      });
  };
  return (
    <div className="flex items-center gap-2">
      <Button
        variant="secondary"
        onClick={onClick}
        disabled={status === "running"}
        aria-label="Undo"
      >
        {status === "running" ? "Undoing..." : "Undo"}
      </Button>
      {status === "error" && error ? (
        <span role="alert" className="text-xs text-accent-danger">
          {error}
        </span>
      ) : null}
    </div>
  );
}
